import { render, staticRenderFns } from "./RootModal.vue?vue&type=template&id=dc163526&scoped=true"
import script from "./RootModal.vue?vue&type=script&lang=js"
export * from "./RootModal.vue?vue&type=script&lang=js"
import style0 from "./RootModal.vue?vue&type=style&index=0&id=dc163526&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc163526",
  null
  
)

export default component.exports